import {Box} from '@mui/material';
import {VerticalResizeType} from '../DocView';
import {ReactComponent as VerticalResize} from '../../../assets/images/Vertical-resize.svg';
import {useCallback, useMemo} from 'react';

interface VerticalResizeProps {
  side: string;
  index: number;
  hoverIndex: number | null;
  showHover: boolean;
  heights: number[];
  leftColRef: React.RefObject<HTMLDivElement | null>;
  rightColRef: React.RefObject<HTMLDivElement | null>;
  verticalResizeRef: React.RefObject<VerticalResizeType>;
  allowResize: boolean;
}
export const VerticalPanelResize = ({
  side,
  index,
  hoverIndex,
  heights,
  showHover,
  leftColRef,
  rightColRef,
  verticalResizeRef,
  allowResize,
  ...props
}: VerticalResizeProps) => {
  const startVerticalResize = useCallback(
    (
      side: string,
      idx: number,
      e: React.MouseEvent<HTMLDivElement, MouseEvent>,
      columnNode: HTMLDivElement | null,
      heights: number[]
    ) => {
      const columnElem =
        columnNode ||
        (side === 'left' ? leftColRef.current : rightColRef.current);
      const containerElem = ((columnElem &&
        columnElem.querySelector &&
        columnElem.querySelector('.col-content')) ||
        columnElem) as HTMLDivElement;
      verticalResizeRef.current = {
        active: true,
        side,
        idx,
        startY: e.clientY,
        startHeights: heights.slice(),
        containerElem,
      };
      document.body.style.cursor = 'row-resize';
    },
    [leftColRef, rightColRef, verticalResizeRef]
  );

  const showIndicator = useMemo(
    () => showHover && hoverIndex === index + 1,
    [hoverIndex, index, showHover]
  );

  return (
    <Box
      key={`vhandle-${side}-${index}`}
      className={`vhandle ${showIndicator ? 'dropInd' : ''}`}
      onMouseDown={(e) => {
        if (allowResize)
          startVerticalResize(
            side,
            index,
            e,
            side === 'left' ? leftColRef.current : rightColRef.current,
            heights
          );
      }}
      {...props}
    >
      {!showIndicator && <VerticalResize />}
    </Box>
  );
};
